import { CanActivateFn } from '@angular/router';
import { inject} from '@angular/core';
import { Router } from '@angular/router';
import { AesEncDecService } from '../services/aes/aes-enc-dec.service'; 

export const authGuard: CanActivateFn = (route, state) => {
  const router=inject(Router);
  const localStorage = inject(AesEncDecService);
  const  localData = localStorage?.getData("loginUserId")?.toString() || null;
  const  localPage = localStorage?.getData("loginPage")?.toString() || null;
  const jsonData =localStorage?.getData("loginDetails")?.toString() || '{}';
  const dataArray = JSON.parse(jsonData);
  const firstObject = dataArray[0];
if(localData!=null){
  return true;
}
else if(localPage!=null){
  return true;
}
// else if(firstObject!=null && (state.url!="/otp-page" && state.url!="/reset-password")){
  else if(firstObject!=null && state.url!="/otp-page"){
  return true;
}
// else if(firstObject!=null && state.url=="/reset-password"){
//   return true;
// }
else{
  router.navigateByUrl("login");
  return false;
}

  
};
